import { GetDeliveryCountriesState } from './getDeliveryCountries.types'

const initialState: GetDeliveryCountriesState = {
  loading: false,
  error: null,
  success: null
  // Initialize any additional state properties here
}

export default initialState
